
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2C323A","stroke":"#fff","d":"M1.1.5h15v12.333h-15z"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.933 0H5.267v3.333H.6V10h4.667v3.333h6.666V10H16.6V3.333h-4.667V0z"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.933 0H5.267v3.333H.6V10h4.667v3.333h6.666V10H16.6V3.333h-4.667V0z","fill":"#2C323A"}}),_c('path',{attrs:{"d":"M5.267 0v-1h-1v1h1zm6.666 0h1v-1h-1v1zM5.267 3.333v1h1v-1h-1zm-4.667 0v-1h-1v1h1zM.6 10h-1v1h1v-1zm4.667 0h1V9h-1v1zm0 3.333h-1v1h1v-1zm6.666 0v1h1v-1h-1zm0-3.333V9h-1v1h1zm4.667 0v1h1v-1h-1zm0-6.667h1v-1h-1v1zm-4.667 0h-1v1h1v-1zM5.267 1h6.666v-2H5.267v2zm1 2.333V0h-2v3.333h2zm-5.667 1h4.667v-2H.6v2zM1.6 10V3.333h-2V10h2zm3.667-1H.6v2h4.667V9zm1 4.333V10h-2v3.333h2zm5.666-1H5.267v2h6.666v-2zm-1-2.333v3.333h2V10h-2zM16.6 9h-4.667v2H16.6V9zm-1-5.667V10h2V3.333h-2zm-3.667 1H16.6v-2h-4.667v2zm-1-4.333v3.333h2V0h-2z","fill":"#2C323A","mask":"url(#a)"}})])
          )
        }
      }
    